const STORAGE_KEY = "feedvote_acquisition_v1";

export function buildAcquisitionContext(href: string, referrer: string) {
  const url = new URL(href);
  const path = url.pathname;
  const invited = /^\/(?:invite|customer-invite)(?:\/|$)/.test(path);
  // Store known marketing paths only. Never persist invitation/reset tokens.
  const landingPath = invited ? "/invite" :
    /^\/(?:blog(?:\/[a-z0-9-]+)?|linear[a-z0-9-]*|pricing|signup|about|contact)?\/?$/.test(path) ? path : "/other";
  let referrerHost = "direct";
  try { referrerHost = new URL(referrer).hostname; } catch { /* no referrer */ }
  return {
    acquisition_landing_path: landingPath,
    acquisition_referrer_host: referrerHost,
    acquisition_is_invitation: invited,
  };
}

export function getAcquisitionContext(): Record<string, unknown> {
  if (typeof window === "undefined") return {};
  if (!["feedvote.app", "www.feedvote.app", "localhost", "127.0.0.1"].includes(window.location.hostname)) return {};
  try {
    const saved = window.localStorage.getItem(STORAGE_KEY);
    if (saved) {
      const parsed = JSON.parse(saved);
      if (parsed && typeof parsed.acquisition_landing_path === "string" &&
          typeof parsed.acquisition_referrer_host === "string" &&
          typeof parsed.acquisition_is_invitation === "boolean") {
        return {
          acquisition_landing_path: parsed.acquisition_landing_path,
          acquisition_referrer_host: parsed.acquisition_referrer_host,
          acquisition_is_invitation: parsed.acquisition_is_invitation,
        };
      }
    }
    const context = buildAcquisitionContext(window.location.href, document.referrer);
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(context));
    return context;
  } catch {
    return buildAcquisitionContext(window.location.href, document.referrer);
  }
}
